module.exports = {"513325100":"河口镇","513325101":"呷拉镇","513325102":"西俄洛镇","513325103":"红龙镇","513325104":"麻郎措镇","513325105":"波斯河镇","513325201":"八角楼乡","513325202":"普巴绒乡","513325203":"祝桑乡","513325204":"米龙乡","513325205":"八衣绒乡","513325208":"牙衣河乡","513325211":"德差乡","513325213":"柯拉乡","513325214":"瓦多乡","513325215":"木绒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513325.json
// module id = 2547
// module chunks = 0